module.exports = global.config = {
    //restUrl: "https://localhost:7158/api/"
    restUrl: "https://cws-dev.kone.com/api/",
    environment: "qa",
    pdmUrl: "https://pdm-qa.aws.kone.com/epdm_qa/"
};